export default "__VITE_ASSET__d7866943__"